import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  levelAlert: {
    backgroundColor: theme.palette.subscription.primary.light,
    color: theme.palette.primary.main,
    alignItems: 'center',
  },
  levelAlertTitle: {
    margin: '8px 0',
    fontWeight: 700,
    textDecoration: 'underline',
  },
  boxButtons: {
    flexDirection: 'row',
  },
}))

export default styles
